import { render, staticRenderFns } from "./SubmitBar.vue?vue&type=template&id=3cc6484c&scoped=true&"
import script from "./SubmitBar.vue?vue&type=script&lang=js&"
export * from "./SubmitBar.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBar.vue?vue&type=style&index=0&id=3cc6484c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6484c",
  null
  
)

component.options.__file = "src/components/submit-bar/SubmitBar.vue"
export default component.exports